import { useEffect, useRef } from 'react';
import { rachelEventBus } from './rachelEventBus';
import type { ChangedEffect, RachelResource } from './uiEffect.schema';

interface UseRachelEventListenerParams {
  resource: RachelResource;
  scopeId: string;
  onChange: (event: ChangedEffect) => void;
}

export const useRachelEventListener = ({
  resource,
  scopeId,
  onChange,
}: UseRachelEventListenerParams): void => {
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(
    () => rachelEventBus.subscribe(resource, scopeId, (event) => onChangeRef.current(event)),
    [resource, scopeId],
  );
};
